export default __webpack_public_path__ + "static/cervin-logo-2577964f0945f06ff56004e9caf4262c.png";